import request from '@/utils/request';
/**
 * 新增筹款助力
 * */
export function postFundAssist(data) {
    return request({
        url: `/fund/assist`,
        method: 'post',
        data
    });
}
/**
 * 查询用户助力等级
 * */
export function getAssistLevel(params) {
    return request({
        url: `/fund/assist/level`,
        method: 'get',
        params
    });
}
/**
 * 用户助力列表
 * */
export function getAssistList(uuid, params) {
    return request({
        url: `/fund/assist/list/${uuid}`,
        method: 'get',
        params
    });
}
/*更新助力次数*/
export function updateAssistCount(data) {
    return request({
        url: `/fund/assist/count`,
        method: 'post',
        data
    });
}
/**
 * 获取项目总点击次数
* */
export function getAssistCount(uuid) {
    return request({
        url: `/fund/assist/count/${uuid}`,
        method: 'get',
    });
}
/**
 * 获取项目总助力金额
 * */
export function getAssistAmount(uuid) {
    return request({
        url: `/fund/assist/amount/${uuid}`,
        method: 'get',
    });
}
/**
 * 获取用户关注公众号二维码
 * */
export function getOfficialqrCodes(data) {
    return request({
        url: `/official-account/fund/qr-codes`,
        method: 'post',
        data
    });
}
